document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("main-search")) {
    customElements.define(
      "main-search",
      class MainSearch extends HTMLElement {
        constructor() {
          super();
          this.searchForm = this.querySelector('.search-modal__form');
        }

        connectedCallback() {
          if (this.searchForm) {
            this.searchForm.addEventListener('submit', this.submitForm.bind(this));
          }
        }

        submitForm(e) {
          e.preventDefault();

          // 获取当前URL中的参数
          const urlParams = new URLSearchParams(window.location.search);
          const isCustomBlog = urlParams.get('custom_type') === 'blog';
          
          // 获取搜索输入值
          const searchInput = this.searchForm.querySelector('input[name="q"]');
          const searchTerm = searchInput ? searchInput.value : '';

          if (!searchTerm.trim()) return false;

          // 构建搜索URL
          const searchParams = new URLSearchParams();
          searchParams.append('q', searchTerm);
          searchParams.append('options[prefix]', 'last');
          
          // 根据条件设置搜索类型
          if (isCustomBlog) {
            searchParams.append('type', 'article');
            searchParams.append('custom_type', 'blog');
          } else {
            // 使用默认搜索类型或从表单中获取
            const typeInput = this.searchForm.querySelector('input[name="type"]');
            if (typeInput) {
              searchParams.append('type', typeInput.value);
            }
          }

          // 跳转到搜索结果页
          const searchUrl = `${window.location.pathname}?${searchParams.toString()}`;
          window.location.href = searchUrl;

          return false;
        }
      }
    );
  }
});
